export const SITE_URL = "https://thesoulskinspa.in";

export const BUSINESS = {
  name: "The Soul Skin Spa & Salon",
  shortName: "Soul Skin",
  tagline: "Sanctuary for Mind, Body & Elemental Renewal",
  phone: "+91 7995280296",
  phoneClean: "+917995280296",
  phoneDisplay: "+91 79952 80296",
  address:
    "502, Greenlands Rd, Divyashakti Appartments, Ameerpet, Hyderabad, Telangana 500016",
  addressShort: "Ameerpet, Hyderabad, Telangana 500016",
  landmark: "Greenlands Road, Divyashakti Apartments, Ameerpet",
  city: "Hyderabad",
  website: SITE_URL + "/",
  mapsEmbedSrc:
    "https://www.google.com/maps?q=Divyashakti+Apartments+Greenlands+Road+Ameerpet+Hyderabad+Telangana+500016&output=embed",
  mapsDirectionsUrl:
    "https://www.google.com/maps/search/?api=1&query=" +
    encodeURIComponent(
      "502, Greenlands Rd, Divyashakti Appartments, Ameerpet, Hyderabad, Telangana 500016"
    ),
};
